import React, { useState } from 'react';
import ReactDOM from 'react-dom';
import { AppContextProvider } from '../../../../Services/AppContext';
import { loadDOMComponent } from '../../../../helpers';
import { store } from '../../../../store/store';
import { Provider } from 'react-redux';
import WizardTermSelectWrapper from './WizardTermSelectWrapper';

loadDOMComponent({
	selector: 'react-wizard-term-select',
	callback: ({ container, context }: any) => {
		const workplaceId = container.getAttribute('workplaceId');
		const workplaceMemberId = container.getAttribute('workplaceMemberId');
		const workplaceCaseTypeId = container.getAttribute('workplaceCaseTypeId');
		const minDate = container.getAttribute('minDate');
		const maxDate = container.getAttribute('maxDate');
		const preselectedDateTime = container.getAttribute('preselectedDateTime');

		ReactDOM.render(
			<Provider store={store}>
				<AppContextProvider {...context}>
					<WizardTermSelectWrapper
						workplaceId={workplaceId}
						workplaceMemberId={workplaceMemberId}
						workplaceCaseTypeId={workplaceCaseTypeId}
						maxDate={maxDate}
						minDate={minDate}
						preselectedDateTime={preselectedDateTime}
					/>
				</AppContextProvider>
			</Provider>,
			container,
		);
	},
});
